import React from 'react';
import SocialsMain from './SocialsMain';

export default function SocialsPage() {
  return (
    <div className="socials-page">
      <SocialsMain />
    </div>
  );
} 